import React, { useLayoutEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Home } from "@/pages";
import { WealthManagement } from "@/pages/WealthManagement";
import { CreditUnions } from "@/pages/CreditUnions";
import { Employers } from "@/pages/Employers";

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/wealthmanagers" element={<WealthManagement />} />
          <Route path="/creditunions" element={<CreditUnions />} />
          <Route path="/employers" element={<Employers />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
